export default __webpack_public_path__ + "static/media/explore-iv-banner-1@3x.5bc79379.png";